/**
 * ============================================================================
 * CONSTANTS - FRONTEND
 * ============================================================================
 */

// API Configuration
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000/api/v1';

// App Configuration
export const APP_NAME = 'WekaTrust';
export const APP_VERSION = '1.0.0';

// Currency
export const CURRENCY = 'XAF';
export const CURRENCY_SYMBOL = 'FCFA';

// Payment Methods
export const PAYMENT_METHODS = {
  MTN_MOMO: 'mtn_momo',
  ORANGE_MONEY: 'orange_money',
  MPESA: 'mpesa',
  AIRTEL_MONEY: 'airtel_money',
  CARD: 'card',
  BANK_TRANSFER: 'bank_transfer',
};

// Transaction Status
export const TRANSACTION_STATUS = {
  CREATED: 'created',
  LINK_SENT: 'link_sent',
  PAYMENT_PENDING: 'payment_pending',
  ESCROW_FUNDED: 'escrow_funded',
  IN_PROGRESS: 'in_progress',
  DELIVERED: 'delivered',
  DISPUTED: 'disputed',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  REFUNDED: 'refunded',
};

// Escrow Status
export const ESCROW_STATUS = {
  PENDING: 'pending',
  FUNDED: 'funded',
  RELEASED: 'released',
  REFUNDED: 'refunded',
  FROZEN: 'frozen',
  CANCELLED: 'cancelled',
};

// Dispute Status
export const DISPUTE_STATUS = {
  OPEN: 'open',
  NEGOTIATING: 'negotiating',
  MEDIATION_REQUESTED: 'mediation_requested',
  IN_MEDIATION: 'in_mediation',
  RESOLVED: 'resolved',
  CLOSED: 'closed',
};

// User Roles
export const USER_ROLES = {
  USER: 'user',
  ADMIN: 'admin',
  MODERATOR: 'moderator',
};

// Verification Levels
export const VERIFICATION_LEVELS = {
  NONE: 0,
  BASIC: 1,
  STANDARD: 2,
  VERIFIED: 3,
};

// Storage Keys
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  USER: 'user',
};

// Routes
export const ROUTES = {
  HOME: '/',
  LOGIN: '/auth/login',
  SIGNUP: '/auth/signup',
  VERIFY_OTP: '/auth/verify-otp',
  FORGOT_PASSWORD: '/auth/forgot-password',
  RESET_PASSWORD: '/auth/reset-password',
  SET_PASSWORD: '/auth/set-password',
  DASHBOARD: '/dashboard',
  TRANSACTIONS: '/transactions',
  TRANSACTION_DETAIL: '/transactions/:id',
  CREATE_TRANSACTION: '/transactions/create',
  WALLET: '/wallet',
  PROFILE: '/profile',
  SETTINGS: '/settings',
  PRIVACY: '/settings/privacy',
  PUBLIC_TRANSACTION: '/t/:shortLink',
  PAYMENT_HISTORY: '/payments/history',
  PAYMENT: '/transactions/:transactionId/pay/:methodId?',
  PAYMENT_SUCCESS: '/payments/success/:paymentId',
  DISPUTES: '/disputes',
  DISPUTE_DETAIL: '/disputes/:id',
  RAISE_DISPUTE: '/disputes/raise',
  DELIVERY_HISTORY: '/deliveries',
  MARK_DELIVERED: '/transactions/:id/deliver',
  DELIVERY_APPROVAL: '/transactions/:id/approve',
  PUBLIC_PROFILE: '/users/:userId',
  SECURITY: '/security',
  VERIFICATION: '/verification',
  ESCROWS: '/escrows',
  ESCROW_DETAIL: '/escrows/:id',
  LINKS: '/links',
  LINK_DETAIL: '/links/:transactionId',
  STORAGE: '/storage',
  ANALYTICS: '/analytics',
  NOTIFICATIONS: '/notifications',
  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_USERS: '/admin/users',
  ADMIN_TRANSACTIONS: '/admin/transactions',
  ADMIN_DISPUTES: '/admin/disputes',
  ADMIN_FINANCE: '/admin/finance',
  ADMIN_SETTINGS: '/admin/settings',
  ADMIN_NOTIFICATIONS: '/admin/notifications',
  ADMIN_PROFILE: '/admin/profile',
  ADMIN_USER_VERIFICATION: '/admin/user-verification',
  ADMIN_ESCROWS: '/admin/escrows',
  ADMIN_ESCROW_DETAIL: '/admin/escrows/:id',
  ADMIN_ANALYTICS: '/admin/analytics',
  ADMIN_PAYMENTS: '/admin/payments',
  ADMIN_PAYMENT_DETAIL: '/admin/payments/:id',
  ADMIN_SECURITY: '/admin/security',
  // New Pages
  DATA_EXPORT: '/settings/data-export',
  ACCOUNT_DELETION: '/settings/delete-account',
  TERMS: '/terms',
  PRIVACY_POLICY: '/privacy',
  HELP: '/help',
  CONTACT: '/contact',
  PRICING: '/pricing',
  USER_SEARCH: '/users/search',
  HOW_IT_WORKS: '/how-it-works',
  SYSTEM_STATUS: '/status',
  ABOUT: '/about',
};

// Date Formats
export const DATE_FORMATS = {
  SHORT: 'MMM DD, YYYY',
  LONG: 'MMMM DD, YYYY',
  DATETIME: 'MMM DD, YYYY HH:mm',
  TIME: 'HH:mm',
};

// Limits
export const LIMITS = {
  MIN_TRANSACTION_AMOUNT: 100,
  MAX_TRANSACTION_AMOUNT: 5000000,
  MIN_WITHDRAWAL_AMOUNT: 100,
  MAX_WITHDRAWAL_AMOUNT: 500000,
  MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
  MAX_PHOTO_SIZE: 5 * 1024 * 1024, // 5MB
};

export default {
  API_BASE_URL,
  APP_NAME,
  APP_VERSION,
  CURRENCY,
  CURRENCY_SYMBOL,
  PAYMENT_METHODS,
  TRANSACTION_STATUS,
  ESCROW_STATUS,
  DISPUTE_STATUS,
  USER_ROLES,
  VERIFICATION_LEVELS,
  STORAGE_KEYS,
  ROUTES,
  DATE_FORMATS,
  LIMITS,
};
